// extracted by mini-css-extract-plugin
module.exports = {"title":"ProductRelations_title__a47d9","titleCenter":"ProductRelations_titleCenter__5aec9"};